function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import useAppGroup from '../../helpers/hooks/useAppGroup';
import { cmsActions } from '../../reducers/cms.reducer';
import Select from '../common/form/Select.react';
var NavigationSlot = function NavigationSlot(_ref) {
  var selected = _ref.selected,
    navArr = _ref.navArr,
    slotAction = _ref.slotAction;
  var _useParams = useParams(),
    app = _useParams.app;
  var appGroup = useAppGroup({
    app: app
  });
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 1),
    position = _useState2[0];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    items = _useState4[0],
    setItems = _useState4[1];
  useEffect(function () {
    setItems(Object.values(navArr).filter(function (x) {
      return x.clientApp === app;
    }).filter(function (x) {
      return x.navbar === selected.navbar;
    }).filter(function (x) {
      return x._id !== selected._id;
    }).filter(function (x) {
      return x.parentID === selected.parentID;
    }).sort(function (a, b) {
      return a.slot - b.slot;
    }));
  }, [selected, navArr, app]);
  var firstItem = [{
    sLabel: 'First',
    sValue: 0
  }];
  items.forEach(function (x, i) {
    firstItem.push({
      sLabel: "After ".concat(x.title),
      sValue: i + 1
    });
  });
  var permissionKey = function permissionKey() {
    if (appGroup === 'pos') return 'edit-pos-navigation';else if (app === 'ppark') return 'edit-ppark-navigation';else if (app === 'construx') return 'edit-construx-navigation';
  };
  var handleOnChange = function handleOnChange(_ref2) {
    var sValue = _ref2.sValue;
    var arr = [];
    var count = 0;
    for (var i = 0; i < items.length + 1; i++) {
      if (i === sValue) {
        arr.push(_objectSpread(_objectSpread({}, selected), {}, {
          slot: sValue
        }));
      } else {
        arr.push(_objectSpread(_objectSpread({}, items[count]), {}, {
          slot: i
        }));
        count++;
      }
    }
    slotAction({
      formData: {
        slot: arr.map(function (x) {
          return {
            _id: x._id,
            slot: x.slot
          };
        })
      },
      route: 'navigation'
    });
  };
  return /*#__PURE__*/React.createElement(Select, {
    value: position,
    options: firstItem,
    onChange: function onChange(position) {
      handleOnChange(position);
    },
    placeholder: "Select to change position",
    permission: permissionKey()
  });
};
var mdtp = {
  slotAction: cmsActions.tmpSlot
};
export default connect(null, mdtp)(NavigationSlot);